import { render, staticRenderFns } from "./staticpage.vue?vue&type=template&id=d782dcea&scoped=true&"
import script from "./staticpage.vue?vue&type=script&lang=js&"
export * from "./staticpage.vue?vue&type=script&lang=js&"
import style0 from "./staticpage.vue?vue&type=style&index=0&id=d782dcea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d782dcea",
  null
  
)

export default component.exports